import { IconError16, Inline, Stack, Text } from '@stitch-fix/mode-react';
import ReCAPTCHA from 'react-google-recaptcha';

const RECAPTCHA_SITE_KEY = process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY ?? '';

interface ReCaptchaWrapperProps {
  onChange: (token: string | null) => void;
}

export const ReCaptchaWrapper = ({ onChange }: ReCaptchaWrapperProps) => (
  <Stack variant="error-light" p={1} spacing={0.875} data-testid="recaptcha">
    <ReCAPTCHA sitekey={RECAPTCHA_SITE_KEY} onChange={onChange} />
    <Inline spacing={0.25} vAlign="center">
      <IconError16 title="error icon" />
      <Text setting="body-small">Please check the box to continue.</Text>
    </Inline>
  </Stack>
);
